export default __webpack_public_path__ + "static/BT_Benefits_Carousel_03-aaf52c8c4e6af320923f6895858c8acd.png";